import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { Providers } from './app/providers';
import { router } from './app/router';
import { setupI18n } from './i18n';
import './styles/index.css';

const container = document.getElementById('root');
if (!container) throw new Error('#root not found');

// Язык поднимается до первого рендера: иначе интерфейс мигнёт английским,
// а потом переключится — на медленном соединении это заметно.
void setupI18n().then(() => {
  createRoot(container).render(
    <StrictMode>
      <Providers>
        <RouterProvider router={router} />
      </Providers>
    </StrictMode>,
  );
});
